import type {AppSpec, AppStruct} from '@cohort/shared/schema/apps/app';
import type {UserPropertySpec, UserPropertyStruct} from '@cohort/shared/schema/apps/userProperty';
import {createBaseAppUserPropertySpec} from '@cohort/shared/schema/apps/userProperty';
import type {YoutubeConnectorStruct} from '@cohort/shared/schema/apps/youtube/userConnector';
import {YoutubeConnectorSpec} from '@cohort/shared/schema/apps/youtube/userConnector';

export const YOUTUBE_APP_ID = 'youtube' as const;
export const YOUTUBE_APP_NAME = 'Youtube' as const;

export const YoutubeUserPropertiesSpecs = [
  ...createBaseAppUserPropertySpec(YOUTUBE_APP_ID, YOUTUBE_APP_NAME),
] as const satisfies ReadonlyArray<UserPropertySpec<UserPropertyStruct>>;
type YoutubeUserPropertyIds = (typeof YoutubeUserPropertiesSpecs)[number]['id'];

export type YoutubeAppStruct = AppStruct<
  'youtube',
  null,
  YoutubeConnectorStruct,
  null,
  never,
  never,
  never,
  never,
  never,
  YoutubeUserPropertyIds,
  never
>;

export const YoutubeAppSpec: AppSpec<YoutubeAppStruct> = {
  id: YOUTUBE_APP_ID,
  name: YOUTUBE_APP_NAME,
  merchantConnector: null,
  userConnector: YoutubeConnectorSpec,
  usersSyncSpec: null,
  actionSpecs: [],
  notificationIntegrationSpecs: [],
  perkIntegrationSpecs: [],
  triggerIntegrationSpecs: [],
  userEventSpecs: [],
  userPropertySpecs: YoutubeUserPropertiesSpecs,
  resourceSpecs: [],
};
